export default __webpack_public_path__ + "static/media/profile-pic-2.84a58137.jpg";